const root = `blade-auth/oauth/`
const urls = {
  login: root + 'token',
  captcha: root + 'captcha'
}
const login = obj => {
  return $http.post(urls.login, obj, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
const captcha = () => {
  return $http.get(urls.captcha)
}

export default {
  login,
  captcha
}
